import { render, staticRenderFns } from "./BuildingViewer.vue?vue&type=template&id=fb05e356&"
import script from "./BuildingViewer.vue?vue&type=script&lang=js&"
export * from "./BuildingViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports